import { flow } from "fp-ts/function";
import type { MapGeoJSONFeature } from "maplibre-gl";
import type { MapboxGeoJSONFeature } from "react-map-gl";
import z from "zod";
import type { SafeFeature, SafePoint } from "./types";

export const materialGeoJsonPropertiesSchema = z.object({
  id: z.string(),
  accessionNumber: z.string(),
  qualifier: z.string(),
  scientificName: z.string(),
  materialNumber: z.string(),
});

export const getFirstFeature = (event: {
  features?: Array<MapboxGeoJSONFeature | MapGeoJSONFeature> | undefined;
}): SafeFeature | undefined => event.features?.[0];

export const getFeaturePoint = flow(
  getFirstFeature,
  (feature): SafePoint | undefined =>
    feature?.geometry.type === "Point" ? (feature as SafePoint) : undefined,
);
